const itemResultCssClass = (item) => item.class_name || ''

const itemSelectionCssClass = (item) => {
  if (item && item.selection_class_name !== undefined) {
    return item.selection_class_name
  } else if (item) {
    return itemResultCssClass(item)
  }
  return ''
}

const formatResult = (item) => {
  if (item.class_name) {
    const classes = item.class_name.split(' ').map(cls => 'in-' + cls)
    return `<span class="${classes.join(' ')}">${item.text}</span>`
  }
  return item.text
}

const formatSelection = (item) => {
  let classes = item.selection_class_name || item.class_name
  if (classes) {
    classes = classes.split(' ')
    return `<span class="${classes.join(' ')}">${item.text}</span>`
  }
  return item.text
}

const paramsCollection = ($input, term) => {
  const additionalUserData = $input.data('s2-options')
  let collection = {}
  if (additionalUserData) {
    const additionalAjaxData = additionalUserData.additional_ajax_data
    if (additionalAjaxData) {
      let functionCollection = {}
      if (typeof window[additionalAjaxData.function] === 'function') {
        functionCollection = window[additionalAjaxData.function]($input, term)
      }
      $(additionalAjaxData.selector).each((_, el) => {
        const $el = $(el)
        collection[$el.attr('name')] = $el.val()
      })
      collection = { ...collection, ...additionalAjaxData.params, ...functionCollection }
      delete collection[$input.attr('name')]
    }
  }
  return collection
}

export const initAutoAjaxSelect2 = () => {
  const $inputs = $('input.auto-ajax-select2')

  $inputs.each(function () {
    const $input = $(this)

    if ($input.data('select2')) {
      return
    }

    const path = $input.data('s2-href')
    const limit = $input.data('s2-limit') || 25

    const customFormatSelection = $input.data('s2-format-selection')
    const customFormatResult = $input.data('s2-format-result')

    const formatSelectionFunc = (customFormatSelection && window[customFormatSelection]) ? window[customFormatSelection] : formatSelection
    const formatResultFunc = (customFormatResult && window[customFormatResult]) ? window[customFormatResult] : formatResult

    const s2DefaultOptions = {
      allowClear: true,
      multiple: false,
      formatSelection: formatSelectionFunc,
      formatResult: formatResultFunc,
      formatResultCssClass: itemResultCssClass,
      ajax: {
        url: path,
        dataType: 'json',
        data: (term, page) => {
          return { ...paramsCollection($input, term), term, page }
        },
        results: (data, page) => {
          const more = (page * limit) < data.total
          return {
            results: data.items,
            more
          }
        }
      },
      initSelection: (element, callback) => {
        const $element = $(element)
        const id = $element.val()
        const initText = $element.data('init-text')
        const initClassName = $element.data('init-class-name')
        const initSelectionClassName = $element.data('init-selection-class-name')

        if (id !== '') {
          if (initText !== undefined) {
            const params = { id, text: initText }
            if (initClassName !== undefined) {
              params.class_name = initClassName
              params.selection_class_name = initSelectionClassName
            }
            callback(params)
          } else {
            $.ajax(path, {
              data: { ...paramsCollection($element, ''), init: true, item_ids: id },
              dataType: 'json'
            }).done(data => {
              if (data) {
                callback(data)
              } else {
                $element.val('')
                callback({ id: '', text: '' })
              }
            })
          }
        }
      }
    }

    const s2UserOptions = $input.data('s2-options')
    const s2FullOptions = s2UserOptions ? { ...s2DefaultOptions, ...s2UserOptions } : s2DefaultOptions

    $input.select2(s2FullOptions)
  })
}

export const AjaxAutoSelect2Initialize = () => {
  initAutoAjaxSelect2()

  document.addEventListener('turbo:before-cache', () => {
    $('input.auto-ajax-select2').select2('destroy')
  })

  document.addEventListener('turbo:before-render', () => {
    $('input.auto-ajax-select2').select2('destroy')
  })

  document.addEventListener('turbo:load', () => {
    initAutoAjaxSelect2()
  })

  $(document).on('ajaxSuccess cocoon:after-insert', () => {
    initAutoAjaxSelect2()
  })
}
